import { CLEAR_STORIES, MapNotificationsToStoriesAction, ScenesActions, StoriesActions, MAP_NOTIFICATIONS_TO_STORIES, SEEN_STORY_SCENE, CLOSE_STORY, OPEN_STORY, NEXT_STORY, PREV_STORY, NEXT_STORY_SCENE, PREV_STORY_SCENE, GO_TO_STORY,  SeenStorySceneAction, OpenStoryAction, GoToStoryAction  } from "./actions";
import { Story, StoryScene } from "../../../models/Story";
import { getNonSeenScene, getNotificationsAsStories } from "../../../utils/stories";
export interface StoriesNavigationState {
    open: boolean,
    stories: Story[],
    currentStoryId: string | '',
    currentScene: null | StoryScene,
}
export const initialStoriesNavigationState: StoriesNavigationState = {
    open: false,
    stories: [],
    currentStoryId: '',
    currentScene: null
}

type StoriesNavigationAction = StoriesActions | ScenesActions

export const storiesNavigationReducer = (state: StoriesNavigationState = initialStoriesNavigationState, action: StoriesNavigationAction): StoriesNavigationState => {
    switch (action.type) {
        case 'FULL_RESET_STORE':
        case CLEAR_STORIES:
            return initialStoriesNavigationState;
        case GO_TO_STORY: {
            const {id} = action as GoToStoryAction
            const allScenes = state.stories.map(item => item.scenes).flat()
            const currentScene = allScenes.find(item => item.id === id)

            return {
                ...state,
                //@ts-ignore
                currentScene: {...currentScene, seen: true}
            }    
        }
        case MAP_NOTIFICATIONS_TO_STORIES: {
            const {notifications} = action as MapNotificationsToStoriesAction
            if(!notifications || !notifications.length) return initialStoriesNavigationState

            const stories = getNotificationsAsStories(notifications)
            if(state.currentScene !== null) {
                return {...state, stories}
            }

            return {...state, stories, currentScene: null, currentStoryId: '', open: false}

        }
        case SEEN_STORY_SCENE: {
            const {storyId, sceneId} = action as SeenStorySceneAction
            const stories = state.stories.map(s => {
                if(s.user.auth0_id !== storyId) return s

                const scenes = s.scenes.map((sc) => {
                    if(sc.id !== sceneId) return sc
                    return {...sc, seen: true}
                })
                return {...s, scenes}
            })

            return {...state, stories}
        }
        case CLOSE_STORY: {
            return {...state, currentStoryId: '', currentScene: null, open: false}
        }
        case OPEN_STORY: {
            const {storyId} = action as OpenStoryAction

            const story = state.stories.find(s => s.user.auth0_id === storyId)
            if(!story) return state

            const currentScene = getNonSeenScene(story.scenes)
            return {
                ...state,
                open: true,
                currentStoryId: storyId,
                currentScene: {...currentScene, seen: true}
            }
        }
        case NEXT_STORY: {
            const {currentStoryId} = state
            const storyInd = state.stories.findIndex(s => s.user.auth0_id === currentStoryId)
            if(storyInd === -1 || storyInd === state.stories.length - 1) return {...state, currentStoryId: '', currentScene: null, open: false}

            const nextStory = state.stories[storyInd + 1]
            const currentScene = getNonSeenScene(nextStory.scenes)

            return {
                ...state,
                open: true,
                currentStoryId: nextStory.user.auth0_id,
                currentScene: {...currentScene, seen: true}
            }
        }
        case PREV_STORY: {
            const {currentStoryId} = state

            const storyInd = state.stories.findIndex(s => s.user.auth0_id === currentStoryId)
            if(storyInd === -1 || storyInd === 0) return {...state, currentStoryId: '', currentScene: null, open: false}

            const nextStory = state.stories[storyInd - 1]
            const currentScene = getNonSeenScene(nextStory.scenes)

            return {
                ...state,
                open: true,
                currentStoryId: nextStory.user.auth0_id,
                currentScene: {...currentScene, seen: true}
            }
        }
        case NEXT_STORY_SCENE: {
            const {currentStoryId, currentScene} = state
            const storyInd = state.stories.findIndex(s => s.user.auth0_id === currentStoryId)
            if(storyInd === -1) return {...state, currentStoryId: '', currentScene: null, open: false}

            const currentStory = state.stories[storyInd]
            if(!currentScene) return {
                ...state,
                currentScene: {...currentStory.scenes[0], seen: true}
            }

            const sceneInd = currentStory.scenes.findIndex(s => currentScene.id === s.id)
            if(sceneInd === -1 || sceneInd === currentStory.scenes.length - 1) return {
                ...state,
                currentScene: {...currentStory.scenes[0], seen: true}
            }

            return {
                ...state,
                currentScene: {...currentStory.scenes[sceneInd + 1], seen: true}
            }
        }
        case PREV_STORY_SCENE: {
            const {currentStoryId, currentScene} = state

            const storyInd = state.stories.findIndex(s => s.user.auth0_id === currentStoryId)
            if(storyInd === -1) return {...state, currentStoryId: '', currentScene: null, open: false}

            const currentStory = state.stories[storyInd]
            if(!currentScene) return {
                ...state,
                currentScene: {...currentStory.scenes[0], seen: true}
            }

            const sceneInd = currentStory.scenes.findIndex(s => currentScene.id === s.id)
            if(sceneInd === -1 || sceneInd === 0) return {
                ...state,
                currentScene: {...currentStory.scenes[0], seen: true}
            }

            return {
                ...state,
                currentScene: {...currentStory.scenes[sceneInd - 1], seen: true}
            }
        }

        default:
            return state
    }
}

export default storiesNavigationReducer